import React from 'react'
import '../../../styles/containers/Prayer/components/faith-card-god.scss';
function FaithCardGod(props) {
    return (
        <div className={`__faith-container d-flex justify-content-center align-items-center ${props.faithSelected? '__faith-selected-border':''}`}>
            <div>
                <span className='__faith-symbol'>{props.symbol.render()}</span>
                <span className={`__faith-name ${props.faithSelected?'__faith-selected-color':''}`}>{props.name}</span>
            </div>
        </div>
    )
}

export default FaithCardGod
